import React from "react";
import { classNames } from "Utils/utils";

const VARIANT_STYLES = {
  success: "bg-green-50 text-green-700 ring-green-600/20",
  warning: "bg-amber-50 text-amber-800 ring-amber-600/20",
  danger: "bg-red-50 text-red-700 ring-red-600/20",
  info: "bg-blue-50 text-blue-700 ring-blue-600/20",
  neutral: "bg-gray-50 text-gray-700 ring-gray-500/20",
};

const PaStatusBadge = ({ label, variant = "neutral", className }) => {
  if (!label) {
    return null;
  }

  return (
    <span
      className={classNames(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset",
        VARIANT_STYLES[variant] || VARIANT_STYLES.neutral,
        className
      )}
    >
      {label}
    </span>
  );
};

export default PaStatusBadge;
